import { call, put, takeEvery } from "redux-saga/effects";
import {
  fetchFormData,
  postLogin,
  tickets,
} from "../../helpers/backend_helper";
import { VIEW_TICKETS } from "../ticket/actionTypes";
import {
  getMyNotification,
  postGeneratePresignedUrl,
  postNotification,
  saveAllUsernVehicle,
  saveBeatsLocations,
  saveGuardLocations,
  saveVehicleLocations,
} from "./actions";
import {
  GENERATE_PRESIGNED_URL,
  GET_ALL_BEATS_LOCATIONS,
  GET_ALL_GUARD_LOCATIONS,
  GET_ALL_USER,
  GET_ALL_VEHICLE_LOCATIONS,
  GET_NOTIFICATION,
  READ_NOTIFICATION,
} from "./actionTypes";

function* getAllGuardLocations() {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "getAllLocation",
    });
    yield put(saveGuardLocations(response?.data));
    return response?.data;
  } catch (error) {
    yield error;
  }
}
function* getAllBeatswithChargeGaurd() {
  try {
    const response = yield call(tickets, {
      act: "ticket",
      subact: "getAllBeatswithChargeGaurd",
    });
    yield put(saveBeatsLocations(response?.data));
    return response?.data;
  } catch (error) {
    yield error;
  }
}
function* getAllVehicleLocations() {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "getAllCarLocation",
    });
    yield put(saveVehicleLocations(response?.data));
    return response?.data;
  } catch (error) {
    yield error;
  }
}
function* getAllNotification(action) {
  const { page, limit } = action.payload;
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "getAllNotifications",
      paggination: {
        page: page,
        limit: limit,
      },
    });
    yield put(postNotification(response?.data));
  } catch (error) {
    yield error;
  }
}

function* readNotification(action) {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "markAsReadNotification",
      info: {
        createdAt: action.payload,
      },
    });
    yield put(getMyNotification(1, 10));
  } catch (error) {
    yield error;
  }
}
function* uploadFileToS3(presignedUrl, file) {
  try {
    const response = yield call(fetch, presignedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!response.ok) {
      throw new Error("File upload failed");
    }

  } catch (error) {
    console.error("Error uploading file to S3:", error);
    throw error;
  }
}

function* getAllUsers() {
  try {
    const response = yield call(postLogin, {
      act: "user",
      subact: "getAll",
    });
    yield put(saveAllUsernVehicle(response.data));
  } catch (error) {
  }
}


/**
 * Handle pre-signed URL generation and file upload
 */
function* generatepresignedUrl(action) {
  try {
    const { fileName, file } = action.payload;

    // Request pre-signed URL
    const response = yield call(fetchFormData, {
      act: "common",
      subact: "generatePresignedUrl",
      info: { fileName },
    });

    const presignedUrl = response?.data;
    if (!presignedUrl) {
      throw new Error("Missing presigned URL in response");
    }

    // Upload file to the S3 bucket
    yield call(uploadFileToS3, presignedUrl, file);

    // Dispatch action with the pre-signed URL
    yield put(postGeneratePresignedUrl(presignedUrl));
  } catch (error) {
    console.error("Error generating presigned URL or uploading file:", error);
  }
}
function* commonSaga() {
  yield takeEvery(GET_ALL_GUARD_LOCATIONS, getAllGuardLocations);
  yield takeEvery(GET_NOTIFICATION, getAllNotification);
  yield takeEvery(READ_NOTIFICATION, readNotification);
  yield takeEvery(VIEW_TICKETS, tickets);
  yield takeEvery(GENERATE_PRESIGNED_URL, generatepresignedUrl);
  yield takeEvery(GET_ALL_VEHICLE_LOCATIONS, getAllVehicleLocations);
  yield takeEvery(GET_ALL_BEATS_LOCATIONS, getAllBeatswithChargeGaurd);
  yield takeEvery(GET_ALL_USER, getAllUsers);


}

export default commonSaga;
